import "babel-polyfill";

import React from "react";
import ReactDOM from "react-dom";
import { browserHistory } from "react-router";

import Routes from "./routes";
import * as Sentry from "@sentry/browser";

import "./index.css";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://dcbe98988f7447038ef6cbd082b49014@sentry.io/149914"
  });
}

ReactDOM.render(
  <Routes history={browserHistory} />,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js